import Route from '@ember/routing/route';
import { instrumentRoutePerformance } from '@sentry/ember';

class ScansScanProductAutomatedReportsRoute extends Route {
  model() {
    return this.modelFor('scans.scan.product');
  }
}

export default instrumentRoutePerformance(
  ScansScanProductAutomatedReportsRoute,
);
